/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.6569 16.9706 22 12 22C7.02944 22 3 20.6569 3 19V5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 22C16.9706 22 21 20.6569 21 19V5C21 5 20.5 8 12 8C3.5 8 3 5 3 5V19C3 20.6569 7.02944 22 12 22Z"
				fill="currentColor"
			/>
			<path
				d="M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.6569 16.9706 22 12 22C7.02944 22 3 20.6569 3 19V5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M21.75 13.6064V19C21.75 19.7425 21.2979 20.3305 20.757 20.7568C20.2076 21.1897 19.4591 21.5468 18.6011 21.8328C16.8773 22.4075 14.5435 22.75 12 22.75C9.45654 22.75 7.12274 22.4075 5.39887 21.8328C4.54085 21.5468 3.79239 21.1897 3.24303 20.7568C2.70213 20.3305 2.25 19.7425 2.25 19V13.6064C2.51005 13.7406 2.78453 13.8717 3.07227 13.9987C5.29364 14.9787 8.39684 15.75 12 15.75C15.6032 15.75 18.7064 14.9787 20.9277 13.9987C21.2155 13.8717 21.4899 13.7406 21.75 13.6064Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.75 11.8872V5C21.75 4.25749 21.2979 3.66949 20.757 3.24321C20.2076 2.81026 19.4591 2.45317 18.6011 2.16717C16.8773 1.59254 14.5435 1.25 12 1.25C9.45654 1.25 7.12274 1.59254 5.39887 2.16717C4.54085 2.45317 3.79239 2.81026 3.24303 3.24321C2.70213 3.66949 2.25 4.25749 2.25 5V11.8872C2.65339 12.1345 3.13073 12.385 3.67773 12.6263C5.70636 13.5213 8.60316 14.25 12 14.25C15.3968 14.25 18.2936 13.5213 20.3223 12.6263C20.8693 12.385 21.3466 12.1345 21.75 11.8872ZM4.17149 4.42132C3.80155 4.71287 3.75 4.91409 3.75 5C3.75 5.08591 3.80155 5.28713 4.17149 5.57868C4.53298 5.86356 5.10255 6.15292 5.87321 6.40981C7.4067 6.92097 9.5729 7.25 12 7.25C14.4271 7.25 16.5933 6.92097 18.1268 6.40981C18.8975 6.15292 19.467 5.86356 19.8285 5.57868C20.1985 5.28713 20.25 5.08591 20.25 5C20.25 4.91409 20.1985 4.71287 19.8285 4.42132C19.467 4.13644 18.8975 3.84708 18.1268 3.59019C16.5933 3.07903 14.4271 2.75 12 2.75C9.5729 2.75 7.4067 3.07903 5.87321 3.59019C5.10255 3.84708 4.53298 4.13644 4.17149 4.42132Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M21 12C21 13.6569 16.9706 15 12 15C11.662 15 11.3283 14.9938 11 14.9817M6 14.2361C4.15875 13.6868 3 12.8885 3 12M3 5C3 6.65685 7.02944 8 12 8C12.6874 8 13.3568 7.97431 14 7.92566M3 5C3 3.34315 7.02944 2 12 2C16.9706 2 21 3.34315 21 5M3 5V19C3 20.6569 7.02944 22 12 22C16.9706 22 21 20.6569 21 19V5M21 5C21 5.71443 20.2508 6.37054 19 6.88578"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.6569 16.9706 22 12 22C7.02944 22 3 20.6569 3 19V5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M21.75 13.6064V19.0001C21.75 19.7426 21.2979 20.3306 20.757 20.7569C20.2076 21.1898 19.4591 21.5469 18.6011 21.8329C16.8773 22.4075 14.5435 22.7501 12 22.7501C9.45654 22.7501 7.12274 22.4075 5.39887 21.8329C4.54085 21.5469 3.79239 21.1898 3.24303 20.7569C2.70213 20.3306 2.25 19.7426 2.25 19.0001V13.6064C2.51005 13.7407 2.78453 13.8718 3.07227 13.9987C5.29364 14.9788 8.39684 15.7501 12 15.7501C15.6032 15.7501 18.7064 14.9788 20.9277 13.9987C21.2155 13.8718 21.4899 13.7407 21.75 13.6064Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.75 11.8872V5C21.75 4.25749 21.2979 3.66949 20.757 3.24321C20.2076 2.81026 19.4591 2.45317 18.6011 2.16717C16.8773 1.59254 14.5435 1.25 12 1.25C9.45654 1.25 7.12274 1.59254 5.39887 2.16717C4.54085 2.45317 3.79239 2.81026 3.24303 3.24321C2.70213 3.66949 2.25 4.25749 2.25 5V11.8872C2.65339 12.1345 3.13073 12.385 3.67773 12.6263C5.70636 13.5213 8.60316 14.25 12 14.25C15.3968 14.25 18.2936 13.5213 20.3223 12.6263C20.8693 12.385 21.3466 12.1345 21.75 11.8872ZM4.17149 4.42132C3.80155 4.71287 3.75 4.91409 3.75 5C3.75 5.08591 3.80155 5.28713 4.17149 5.57868C4.53298 5.86356 5.10255 6.15292 5.87321 6.40981C7.4067 6.92097 9.5729 7.25 12 7.25C14.4271 7.25 16.5933 6.92097 18.1268 6.40981C18.8975 6.15292 19.467 5.86356 19.8285 5.57868C20.1985 5.28713 20.25 5.08591 20.25 5C20.25 4.91409 20.1985 4.71287 19.8285 4.42132C19.467 4.13644 18.8975 3.84708 18.1268 3.59019C16.5933 3.07903 14.4271 2.75 12 2.75C9.5729 2.75 7.4067 3.07903 5.87321 3.59019C5.10255 3.84708 4.53298 4.13644 4.17149 4.42132Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
